/**
 * src/components/platform/PlatformHeader.js
 *
 * Encabezado centrado de la sección plataforma.
 * Props: { headline, description }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('PlatformHeader', ({ headline, description }) => {
    return h('div', { className: 'platform-header' },
        h('h2', { className: 'platform-header__headline' }, headline),
        h('p',  { className: 'platform-header__desc' }, description)
    )
})
